// extracted by mini-css-extract-plugin
export default {"box":"UserSettings_box__25zZ4","settingsTitle":"UserSettings_settingsTitle__-1cdO"};